import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ContemporaryLandingFeaturedRow } from './ContemporaryLandingFeaturedRow';

import styles from './ContemporaryLandingFeaturedModule.scss';

const ContemporaryLandingFeaturedModuleComponent = ({ contemporaryLandingRow }) => {
    if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
        return null;
    }
    const featuredRows = contemporaryLandingRow.items.filter(item => item.type === 'featuredRow');

    return (
        <div className={styles.wrapper}>
            <BarHeader title={get(contemporaryLandingRow, 'items[0].text')} />
            {featuredRows.map((featuredRow, index) => (
                <ContemporaryLandingFeaturedRow
                    key={`${featuredRow.type}-${index}`}
                    items={get(featuredRow, 'items')}
                    rowIndex={index}
                />
            ))}
        </div>
    );
};

ContemporaryLandingFeaturedModuleComponent.propTypes = {
    contemporaryLandingRow: PropTypes.object,
};

export const ContemporaryLandingFeaturedModule = createFragmentContainer(
    ContemporaryLandingFeaturedModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingFeaturedModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingFeaturedRowItem {
                                    cta
                                    description
                                    imagePath
                                    linkPath
                                    title
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
